<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
		<b-card>
			<b-row>
				<b-col cols="12">
					<app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
				</b-col>
			</b-row>
			<b-row v-if="isUploadSuccess">
				<b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							<b-tab title="Download Process" active>
								<b-row class="mb-2">
									<b-col>
										<span class="float-right">
											<b-form-select v-model="downloadProcessPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
										</span>
									</b-col>
								</b-row>
								<b-row>
								<b-col>
								<div class="table-corner">
									<b-table id="my-table" stacked="md" head-variant="head-light" :no-local-sorting="true" :items="downloadProcesss" :fields="fieldsDownloadProcess" :busy="isDataLoading" :sort-by.sync="sortByDownloadProcess" :sort-desc.sync="sortDescDownloadProcess" small responsive>
									<template v-slot:head(actions)>
										<b-button @click="isShowDownloadProcessFilter = !isShowDownloadProcessFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
									</template>
									<template #top-row v-if="isShowDownloadProcessFilter">
										<b-th></b-th>
										<b-th stacked-heading="">
											<b-form-input id="input-job-id-table" v-model="filterDownloadProcess.jobId" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Function Id">
											<b-form-input id="input-function-id-table" v-model="filterDownloadProcess.functionId" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="">
											<b-form-input id="input-file-name-table" v-model="filterDownloadProcess.fileName" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Start Time">
											<app-input-datetimepicker-range id="fieldset-start-time" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="Start Time" size="sm" :modelFrom.sync="filter.startTimeFrom" :modelTo.sync="filter.startTimeTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button/>
										</b-th>
										<b-th stacked-heading="End Time">
											<app-input-datetimepicker-range id="fieldset-end-time" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="End Time" size="sm" :modelFrom.sync="filter.endTimeFrom" :modelTo.sync="filter.endTimeTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button/>
										</b-th>
										<b-th stacked-heading="Status">
											<b-form-input id="input-status-table" v-model="filterDownloadProcess.status" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Error Message">
											<b-form-input id="input-error-message-table" v-model="filterDownloadProcess.errorMessage" size="sm"></b-form-input>
										</b-th>
										<b-th>
										</b-th>
									</template>
									<template v-slot:table-busys>
										<div class="text-center my-2">
									<b-spinner class="align-middle text-primary"></b-spinner>
										<strong class="ml-2">Loading..</strong>
										</div>
									</template>
									<template v-slot:cell(no)="row">
										{{ ((row.index + 1) + ( downloadProcessPageSize * (currentDownloadProcessPage - 1))) }}
									</template>
									<template v-slot:cell(startTime)="row">
										{{ row.item.startTime | moment("DD-MMM-YYYY HH:mm")  }}
									</template>
									<template v-slot:cell(endTime)="row">
										{{ row.item.endTime | moment("DD-MMM-YYYY HH:mm")  }}
									</template>
									</b-table>
									</div>
								</b-col>
								<b-col cols="12">
									<b-pagination
									class="float-right btn-paging"
									v-model="currentDownloadProcessPage"
									:total-rows="totalDownloadProcessRow"
									:per-page="downloadProcessPageSize"
									aria-controls="my-table"
									></b-pagination>
								</b-col>
								</b-row>
							</b-tab>
						</b-tabs>
					</b-card>
				</b-col>
			</b-row>
		</b-card>
		<template #modal-footer="{ ok, cancel }">
			<b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
				Download Error Message
			</b-button>
			<b-button size="sm" variant="success" class="float-right" @click="ok()">
				{{ okTitle }}
			</b-button>
			<b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
				Cancel
			</b-button>
		</template>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</b-modal>
</template>
<style lang="scss" scoped>
.card {
	border: 1px solid rgba(0, 0, 0, 0.125) !important;
}
::v-deep.th-message {
	color: red;
}
::v-deep.modal-footer {
	display: block;
}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate"; 
import { required, minLength } from "vuelidate/lib/validators"; 
import { saveAs } from 'file-saver';

import DownloadProcess from '@/models/DownloadProcess/DownloadProcess';
import DownloadProcessList from '@/models/DownloadProcess/DownloadProcessList';
import DownloadProcessFilter from '@/filters/DownloadProcess/DownloadProcessFilter';

import AppInputFileupload from '@/components/AppInputFileupload';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,AppInputDatetimepicker,AppInputDatetimepickerRange,},
	data() {
		return {
			fileupload: null,
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fieldsDownloadProcess: [
				{"no" : { "class" : "th-number"}}, 
				{"jobId": { "class" : "th-job-id", "label" : ""}, key: 'jobId', sortable: true}, 
				{"functionId": { "class" : "th-function-id", "label" : "Function Id"}, key: 'functionId', sortable: true}, 
				{"fileName": { "class" : "th-file-name", "label" : ""}, key: 'fileName', sortable: true}, 
				{"startTime": { "class" : "th-start-time", "label" : "Start Time"}, key: 'startTime', sortable: true}, 
				{"endTime": { "class" : "th-end-time", "label" : "End Time"}, key: 'endTime', sortable: true}, 
				{"status": { "class" : "th-status", "label" : "Status"}, key: 'status', sortable: true}, 
				{"errorMessage": { "class" : "th-error-message", "label" : "Error Message"}, key: 'errorMessage', sortable: true}, 
				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: true},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessage', sortable: true},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			busy:false,
			isDataLoading: false,
			isBusy : false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			downloadProcesss : [],
			downloadProcessId : '',
			totalDownloadProcessRow : 0,
			isShowDownloadProcessFilter: false,
			filterDownloadProcess : null,
			currentDownloadProcessPage : 1,
			downloadProcessPageSize: 10,
			sortByDownloadProcess: '',
			sortDescDownloadProcess: '',
			processId: "",
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post(process.env.VUE_APP_API_URL + 'downloadprocess/confirmUpload',
					[],
					).then(async function(response){
						if (response != null) {
						if (response.data != null) {
							_this.resetModal();
							_this.datas = Array();
							_this.fileupload = null;
							_this.isUploadSuccess = false;
						}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
				let data = new FormData();
				data.append('file', this.fileupload);
				let _this = this;
				this.$http.post(process.env.VUE_APP_API_URL + 'downloadprocess/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.isBusy = false;
						_this.isUploadSuccess = true;
						_this.getDownloadProcesss();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getDownloadProcesss : async function() {
			let filter = {};
			Object.assign(filter, this.filterDownloadProcess);
			filter.draftFromUpload = "1";
			filter.draftMode = "1";
			this.sortingByDownloadProcess = Array();
			if (this.sortByDownloadProcess != null) {
				this.sortingByDownloadProcess[this.sortByDownloadProcess] = this.sortDescDownloadProcess;
			}
			let currentPage = (this.currentDownloadProcessPage - 1);
			DownloadProcess.getList(this, filter, this.sortingByDownloadProcess, currentPage , this.downloadProcessPageSize).then(result => {
				this.downloadProcesss = result.data;
				this.totalDownloadProcessRow = result.dataCount;
			}).catch(error => {});
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		downloadLog() {
			let _this = this;
			this.$http.post(process.env.VUE_APP_API_URL + 'downloadprocess/downloadlog', [],
			{ headers: { 'Content-Type': 'application/json' }}
			).then(async function(response){
				await saveAs(process.env.VUE_APP_API_URL + 'downloadprocess/downloadlog', "DownloadProcess.xslx");
				_this.isBusy = false;
			})
			.catch(error => {
				_this.$store.dispatch('addErrorMessageGlobal', error);
				_this.isBusy = false;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		sortByDownloadProcess : {
			handler: function() {
				this.getDownloadProcesss();
			}
		},
		sortDescDownloadProcess: {
			handler: function() {
				this.getDownloadProcesss();
			}
		},
		currentDownloadProcessPage: {
			handler: function() {
				this.getDownloadProcesss();
			}
		},
		downloadProcessPageSize : {
			handler: function() {
				this.getDownloadProcesss();
			}
		},
		filterDownloadProcess: {
			handler: function() {
				this.getDownloadProcesss();
			},
			deep: true,
		},
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Proses";
				}
				return "Simpan";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterDownloadProcess = new DownloadProcessFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
